<template>
  <div class="overview-item" @click="$emit('selected', item.status)">
    <div class="overview-item__row1">
      <span
        class="overview-item__amount"
        :class="item.status === 'ACTUAL-USED-TOTAL' ? ['overview-item__amount__shrink'] : null"
        >{{ totalPrice }}</span
      >
      <span class="flex-fill"></span>
      <template
        v-if="paymentStatusName && (item.status !== 'TOTAL' && item.status !== 'TOTAL_COUPON')"
      >
        <img
          :src="require(`../../assets/img/paymentstatusimg/status-icn_${status.value}@3x.png`)"
          :alt="status.text"
        />
      </template>
      <template
        v-else-if="item.status !== 'TOTAL' && item.status !== 'TOTAL_COUPON'"
      >
        <img
          :src="require(`../../assets/img/status-icn_${status.value}@3x.png`)"
          :alt="status.text"
        />
      </template>
    </div>
    <div>
      <span class="overview-item__label" style="text-align:justify; word-break:break-all;">
        {{ status.text }}
      </span>
    </div>
    <div
      v-if="item.status === 'ACTIVATED' && item.verifiedBadge !== undefined"
      style="color:#3379ba;font-size:12px;"
    >
      藍剔認證用戶:  {{ item.verifiedBadge }}
    </div>
  </div>
</template>

<script>
import getCouponStatus, { getOverViewStatus, getQrCodeCouponStatus } from '../../helpers/coupon-status';

export default {
  props: {
    item: Object,
    paymentStatusName: String,
    isQrCodeOverview: Boolean,
  },
  computed: {
    status() {
      if (this.paymentStatusName) {
        return getOverViewStatus(this.item.status);
      }
      if (this.isQrCodeOverview) {
        return getQrCodeCouponStatus(this.item.status);
      }
      return getCouponStatus(this.item.status);
    },
    statusImg() {
      if (this.paymentStatusName) {
        return getOverViewStatus(this.item.status);
      }
      if (this.isQrCodeOverview) {
        return getQrCodeCouponStatus(this.item.status);
      }
      return getCouponStatus(this.item.status);
    },
    totalPrice() {
      return this.item.status === 'ACTUAL-USED-TOTAL' ? `HK$${this.item.total.toLocaleString('en-US', { maximumFractionDigits: 2 })}` : this.item.total;
    },
  },
};
</script>

<style lang="scss" scoped>
.overview-item {
  border: 1px solid #dde1e5;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  padding: 16px 12px 16px 16px;
  min-height: 123px;

  &:hover {
    & img {
      transform: scale(1.06);
    }
  }

  & img {
    width: 50px;
    transition: transform 0.5s;

    @include respond(phone) {
      width: 43px;
    }
  }

  &__row1 {
    display: flex;
    align-items: center;
    min-height: 50px; // same as image height
  }

  &__amount {
    color: #3A4047;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 36px;
    display: block;
    font-family: Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

    &__shrink {
      font-size: 2rem;

      @include respond(phone) {
        font-size: 1.3rem;
      }
    }
  }

  &__label {
    color: #696969;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 21px;
    display: block;
    white-space: nowrap;

    @include respond(phone) {
      font-size: 12px;
    }
  }
}
</style>
